import type { Element, GroupElement } from '@/components/canvas/document/publicTypes';
import { drawElement } from '@/components/canvas/rendering/export/drawElement';
import type { GetImageProxyUrl } from '@/components/canvas/rendering/export/types';

export async function drawGroup(
  ctx: CanvasRenderingContext2D,
  el: GroupElement,
  allElements: Element[],
  getImageProxyUrl?: GetImageProxyUrl,
): Promise<void> {
  const { x, y } = el.layout;
  const { children } = el.data;
  ctx.save();
  ctx.translate(x, y);
  const childEls = (children ?? [])
    .map((id) => allElements.find((e) => e.id === id))
    .filter(Boolean) as Element[];
  const sorted = [...childEls].sort((a, b) => a.layout.zIndex - b.layout.zIndex);
  for (const child of sorted) {
    await drawElement(ctx, child, allElements, getImageProxyUrl);
  }
  ctx.restore();
}
